// extracted by mini-css-extract-plugin
export default {"locoabout11":"LocoAbout_locoabout11__v304C"};